import React from "react";
import styles from "./BaseFareName.module.css";
const BaseFareName = ({ flight }) => {
    const { brandedFareInfo } = flight;
    return brandedFareInfo?.fareAttributes?.includes("DISPLAY_FARE_NAME") ? (React.createElement("div", { className: styles.root }, brandedFareInfo.fareName.toLowerCase())) : null;
};
export default BaseFareName;
